import { ApplicationFormValues } from '../../../../../LoanDetailTypes';
import { Ruleset } from '../../../interfaces/Ruleset';
import { RulesetResult } from '../../rules';
import { BaseRuleset } from '../BaseRuleset';

export class SystemPropertyEstimationMethodRuleset
  extends BaseRuleset
  implements Ruleset
{
  public evaluate(data: Partial<ApplicationFormValues>): RulesetResult {
    return RulesetResult.REQUIRED;
  }
}

export default new SystemPropertyEstimationMethodRuleset();
